import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
class PerformanceAppraisalDetails extends Component {
  constructor() {
    super();
    this.state = {
      submit_button:<button className="btn btn-primary w-100 py-3" type="button" onClick={this.add_emp_basic_details.bind(this)}>Update</button>,
      downloads_div:'',
    };
  }


  componentDidMount(){
    this.get_emp_basic_details();
  }
  get_emp_basic_details(){
      var cutThis           = this;
      var emp_id            = cutThis.props.id;
      var web_token         = window.isNullAndUndef($('#web_token').val());
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('web_token',web_token);
      body.append('form_type','employee_performance_and_appraisal_details');
      body.append('function','get_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           data: body
       })
       .then(function (res) {
          var data = res.data;
          if(data['error']==1){
            var new_data = data['data'];
            cutThis.update_info(new_data);
            cutThis.downloads_files(data);
          }

       })
       .catch(function (error) {
           console.log(error);
       });
  }

  downloads_files(data){
    var emp_id  = data['emp_id'];
    var file_id = data['id'];
    var downloads_div = [];
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'kras_and_kpis_assigned')}><i class="fas fa-file-download"></i> KRAs &amp; KPIs Assigned</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'performance_reviews_and_ratings')}><i class="fas fa-file-download"></i> Performance Reviews &amp; Ratings</a></div>);
    downloads_div.push(<div className="col-md-3"><a className="pointer" onClick={this.check_download_file.bind(this,file_id,emp_id,'promotion_and_salary_revision_history')}><i class="fas fa-file-download"></i> Promotion &amp; Salary Revision History</a></div>);
    this.setState({downloads_div});
  }

  check_download_file(file_id,emp_id,file_name){
    var web_token         = window.isNullAndUndef($('#web_token').val());
    var form_type         = 'employee_performance_and_appraisal_details';
    var url = '';
    if(window.location.host ==="localhost:3000"){
      url = "http://localhost/bylawsindia/php/admin_download_employee_files_url.php";
    }else{
      url = "/php/admin_download_employee_files_url.php";
    }
    var new_str = '?emp_id='+emp_id+"&file_id="+file_id+'&file_name='+file_name+"&function=check_download_emp_file&form_type="+form_type+"&web_token="+web_token;
    window.open(url+new_str, '_blank');
  }

  update_info(data){
    $('#old_kras_and_kpis_assigned').val(data['kras_and_kpis_assigned_new_name']);
    $('#old_performance_reviews_and_ratings').val(data['performance_reviews_and_ratings_new_name']);
    $('#old_promotion_and_salary_revision_history').val(data['promotion_and_salary_revision_history_new_name']);
  }

  add_emp_basic_details(){
    var file_main_ext       = ['pdf','PDF'];
    var cutThis             = this;
    var emp_id              = cutThis.props.id;
    var web_token           = window.isNullAndUndef($('#web_token').val());


    var kras_and_kpis_assigned_temp    = window.isNullAndUndef($('#kras_and_kpis_assigned').val());
    var org_kras_and_kpis_assigned     = $("#kras_and_kpis_assigned").prop("files")[0];
    var kras_and_kpis_assigned_name    = $('#kras_and_kpis_assigned').val().split('\\').pop();

    var performance_reviews_and_ratings_temp        = window.isNullAndUndef($('#performance_reviews_and_ratings').val());
    var org_performance_reviews_and_ratings         = $("#performance_reviews_and_ratings").prop("files")[0];
    var performance_reviews_and_ratings_name        = $('#performance_reviews_and_ratings').val().split('\\').pop();

    var promotion_and_salary_revision_history_temp        = window.isNullAndUndef($('#promotion_and_salary_revision_history').val());
    var org_promotion_and_salary_revision_history         = $("#promotion_and_salary_revision_history").prop("files")[0];
    var promotion_and_salary_revision_history_name        = $('#promotion_and_salary_revision_history').val().split('\\').pop();


    var kras_and_kpis_assigned_ext    = '';
    var performance_reviews_and_ratings_ext         = '';
    var promotion_and_salary_revision_history_ext         = '';

    if(kras_and_kpis_assigned_temp && performance_reviews_and_ratings_temp && promotion_and_salary_revision_history_temp){
      kras_and_kpis_assigned_ext       = kras_and_kpis_assigned_temp.split('.').pop();
      performance_reviews_and_ratings_ext        = performance_reviews_and_ratings_temp.split('.').pop();
      promotion_and_salary_revision_history_ext        = promotion_and_salary_revision_history_temp.split('.').pop();
    }

    var submit_button     = <button className="btn btn-primary w-100 py-3" type="button">Update...</button>;
    cutThis.setState({submit_button});
    $('label').removeClass('color_red');
    if(file_main_ext.indexOf(kras_and_kpis_assigned_ext) >= 0 && file_main_ext.indexOf(performance_reviews_and_ratings_ext) >= 0 && file_main_ext.indexOf(promotion_and_salary_revision_history_ext) >= 0){
      var old_kras_and_kpis_assigned                           = $('#old_kras_and_kpis_assigned').val();
      var old_performance_reviews_and_ratings                  = $('#old_performance_reviews_and_ratings').val();
      var old_promotion_and_salary_revision_history            = $('#old_promotion_and_salary_revision_history').val();
      var all_data                                             = {};


      all_data['kras_and_kpis_assigned']                       = window.return_false_null(kras_and_kpis_assigned_name);
      all_data['performance_reviews_and_ratings']              = window.return_false_null(performance_reviews_and_ratings_name);
      all_data['promotion_and_salary_revision_history']        = window.return_false_null(promotion_and_salary_revision_history_name);
      var body = new FormData();
      body.append('emp_id',emp_id);
      body.append('kras_and_kpis_assigned',org_kras_and_kpis_assigned);
      body.append('old_kras_and_kpis_assigned',old_kras_and_kpis_assigned);
      body.append('performance_reviews_and_ratings',org_performance_reviews_and_ratings);
      body.append('old_performance_reviews_and_ratings',old_performance_reviews_and_ratings);
      body.append('promotion_and_salary_revision_history',org_promotion_and_salary_revision_history);
      body.append('old_promotion_and_salary_revision_history',old_promotion_and_salary_revision_history);
      body.append('emp_date',JSON.stringify(all_data));
      body.append('web_token',web_token);
      body.append('form_type','employee_performance_and_appraisal_details');
      body.append('function','add_emp_basic_details');
      var url      = '';
      if(window.location.host ==="localhost:3000"){
        url = "http://localhost/bylawsindia/php/admin_employee_management_url.php";
      }else{
        url = "/php/admin_employee_management_url.php";
      }
      axios({
           method: 'POST',
           url: url,
           async: false,
           data: body,
           enctype: 'multipart/form-data',
           processData: false,
           contentType: false,
           cache: false,
       })
       .then(function (res) {
          var data = res.data;
          $('#error_msg').text(data['msg']);
          submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
          cutThis.setState({submit_button});
          cutThis.get_emp_basic_details();
       })
       .catch(function (error) {
           console.log(error);
       });
    }else {
      window.change_lable_color('kras_and_kpis_assigned','performance_reviews_and_ratings','promotion_and_salary_revision_history');
      submit_button     = <button className="btn btn-primary w-100 py-3" type="button" onClick={cutThis.add_emp_basic_details.bind(cutThis)}>Update</button>;
      cutThis.setState({submit_button});
    }

  }


  render() {
    return (
        <>
        	<div className="mt-4 mb-4">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">{this.props.page_title}</h3>
                <div className="row g-4">


                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                        <form action="" method="post">
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_kras_and_kpis_assigned" placeholder=""/>
                                        <input type="file" className="form-control" id="kras_and_kpis_assigned" placeholder="KRAs &amp; KPIs Assigned"/>
                                        <label for="name">KRAs &amp; KPIs Assigned</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_performance_reviews_and_ratings" placeholder=""/>
                                        <input type="file" className="form-control" id="performance_reviews_and_ratings" placeholder="Performance Reviews &amp; Ratings"/>
                                        <label for="name">Performance Reviews &amp; Ratings</label>
                                    </div>
                                </div>

                                <div className="col-md-4">
                                    <div className="form-floating">
                                        <input type="hidden" className="form-control" id="old_promotion_and_salary_revision_history" placeholder=""/>
                                        <input type="file" className="form-control" id="promotion_and_salary_revision_history" placeholder="Promotion &amp; Salary Revision History"/>
                                        <label for="name">Promotion &amp; Salary Revision History</label>
                                    </div>
                                </div>

                                <div className="col-md-12">
                                    <div className="col-md-4">
                                      <p id="error_msg"></p>
                                    </div>
                                    <div className="col-md-4">
                                      <p># Form upload, only allow PDF</p>
                                    </div>
                                    <div className="col-md-4 p-0 float_r">
                                        {this.state.submit_button}
                                    </div>
                                </div>
                                {this.state.downloads_div}


                            </div>
                        </form>
                    </div>
                </div>

            </div>
        </div>

        </>
    );
  }
}

export default PerformanceAppraisalDetails;
